export default class DeferredUtility {
  static sleep(milliseconds: number): Promise<void> {
    const d = this.newDeferred();
    setTimeout(() => d.resolve(), milliseconds);
    return this.convertJQueryPromise(d.promise());
  }

  static resolvedPromise<T>(value: T): Promise<T> {
    const d = this.newDeferred();
    d.resolve(value);
    return this.convertJQueryPromise(d.promise());
  }

  static rejectedPromise<T>(value: T): Promise<T> {
    const d = this.newDeferred();
    d.reject(value);
    return this.convertJQueryPromise(d.promise());
  }

  static newDeferred() {
    // @ts-ignore
    return window.jQuery.Deferred();
  }

  static convertJQueryPromise<T>(jqPromise: JQuery.Promise<T>): Promise<T> {
    return new Promise<T>((resolve, reject) => {
        jqPromise.done((result: T) => resolve(result));
        jqPromise.fail((error: any) => reject(error));
    });
  }
}
